import PropTypes from "prop-types";
import Image from "next/image";
import config from "../../common/config";
import { stripTrailingSlash } from "../../lib/helpers";
import styles from "./deferredIcon.module.scss";

const DeferredIcon = ({ ext, type, alt, ...restProps }) => {
  const getIconsSrc = (name) =>
    `${stripTrailingSlash(config.ICONS_BASE_URL)}/${name}.${ext}`;

  return (
    <div
      className={styles.deferredIcon}
      style={{ width: restProps.width, height: restProps.height }}
    >
      <Image
        loader={({ src }) => {
          return getIconsSrc(src);
        }}
        priority
        src={type}
        alt={alt}
        layout="responsive"
        {...restProps}
      />
    </div>
  );
};

DeferredIcon.propTypes = {
  type: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  ext: PropTypes.string,
};

DeferredIcon.defaultProps = {
  ext: "svg",
};

export default DeferredIcon;
